import { useState } from 'react';

const useCharacterCount = <T extends HTMLInputElement | HTMLTextAreaElement>(
  initialValue?: string | readonly string[] | number,
  characterCountMax?: number,
  onChange?: (event: React.ChangeEvent<T>) => void,
): [number, (event: React.ChangeEvent<T>) => void] => {
  const [characterCount, setCharacterCount] = useState(initialValue?.toString().length || 0);

  const changeHandler = (event: React.ChangeEvent<T>): void => {
    if (characterCountMax) {
      setCharacterCount(event.target.value.length);
      if (event.target.value.length > characterCountMax) {
        event.target.setCustomValidity('The content is too long.');
      } else {
        event.target.setCustomValidity('');
      }
    }
    if (onChange) {
      onChange(event);
    }
  };

  return [characterCount, changeHandler];
};

export default useCharacterCount;
